import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import './styles/responsive.css'

const RootWrapper = ({ children }) => (
  import.meta.env.MODE === 'production'
    ? <React.StrictMode>{children}</React.StrictMode>
    : <>{children}</>
)

ReactDOM.createRoot(document.getElementById('root')).render(
  <RootWrapper>
    <App />
  </RootWrapper>,
)

// Serviço offline somente para a interface; nunca grava dados sensíveis na cache HTTP.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(error => console.warn('DOMUS offline indisponível:',error))
  })
}
